import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useScrollPosition from '../../../hooks/useScrollPosition';
import Wrapper from './SecondaryNavDesktopWrapper';
import Link from './SecondaryNavDesktopLink';

import * as styles from './SecondaryNavDesktop.module.less';

const SCROLL_THRESHOLD = 200;
const MINIMUM_SCROLL_MOVEMENT_THRESHOLD = 50;

const SecondaryNavDesktop = ({ links }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const previousScrollY = useRef();

  const doScroll = ({ scrollY }) => {
    // Define first value.
    if (typeof previousScrollY.current === 'undefined') {
      previousScrollY.current = scrollY;
      return;
    }

    // Ignore minimal scroll differences to prevent cascading changes
    if (
      Math.abs(scrollY - previousScrollY.current) >
      MINIMUM_SCROLL_MOVEMENT_THRESHOLD
    ) {
      // Check mov direction.
      const hasScrolledUp = previousScrollY.current > scrollY;

      // Store new current scroll Y.
      previousScrollY.current = scrollY;

      // Minify or not.
      const nextIsMinimixed = !hasScrolledUp && scrollY > SCROLL_THRESHOLD;
      if (nextIsMinimixed !== isMinimized) {
        setIsMinimized(nextIsMinimixed);
      }
    }
  };

  useScrollPosition(doScroll, [isMinimized, previousScrollY.current]);

  return (
    <div className={styles.navDesktop}>
      {links.map(link => {
        return (
          <Wrapper
            key={`${link.path}-${link.text}`}
            text={link.text}
            isMinimized={isMinimized}
          >
            {link.childItems.map(childItem => (
              <Link
                key={`${childItem.path}-${childItem.text}`}
                path={childItem.path}
                text={childItem.text}
                childItems={childItem.childItems}
              />
            ))}
          </Wrapper>
        );
      })}
    </div>
  );
};

SecondaryNavDesktop.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

SecondaryNavDesktop.defaultProps = {
  links: [],
};

export default SecondaryNavDesktop;
